import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

import { ReactComponent as Exclamation } from 'assets/icons/exclamation-icon.svg';
import Spinner from 'components/spinner/Spinner';

import TransactionCard from './TransactionCard';

const TransactionList = (props) => {
    if (props.error) {
        return (
            <div className="transaction-list-error">
                <Exclamation />
                <p className="error" id="gtm-error-message-transaction">
                    <FormattedMessage id="transaction.history.api.error" />
                </p>
            </div>
        );
    }

    if (props.isFetching) {
        return (
            <div className="transaction-list-loading">
                <Spinner />
            </div>
        );
    }

    if (!props.transactions) {
        return null;
    }

    if (!props.transactions.length) {
        return (
            <div className="transaction-list-empty">
                <p className="info" id="gtm-message-no-transaction">
                    <FormattedMessage id="transaction.history.api.empty.array" />
                </p>
            </div>
        );
    }

    return (
        <ul className="transaction-list">
            {props.transactions.length > 0 ? (
                <p className="transaction-list-label">
                    <FormattedMessage id="transaction.list.label" />
                </p>
            ) : null}
            {props.transactions.map((transaction, i) => (
                <li key={`${transaction.planId}-${i}`}>
                    <TransactionCard {...transaction} />
                </li>
            ))}
        </ul>
    );
};

TransactionList.propTypes = {
    error: PropTypes.any,
    isFetching: PropTypes.bool.isRequired,
    transactions: PropTypes.array,
};

export default TransactionList;
